module.exports = __webpack_public_path__ + "img/button_right_dark.d2bc9392.png";